export default (ob: unknown): number => {
  try {
    return JSON.stringify(ob).length;
  } catch (err) {
    return -1;
  }
};
